import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckSquare } from "lucide-react";
import api from "@/api";
import { ProgressBar } from "@/components/OwnToggle";

/* Bande d'accueil du compteur de collection. Un visiteur voit une barre d'EXEMPLE — étiquetée
   comme telle, jamais présentée comme sa collection — construite sur un vrai set du catalogue.
   Un visiteur connecté voit son set le plus avancé. */
export default function CollectionStrip({ t }) {
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get("/collection/progress").then((r) => setD(r.data)).catch(() => setD(null));
  }, []);
  if (!d) return null;
  const mine = Object.entries(d.sets || {}).map(([slug, s]) => ({ slug, ...s })).sort((a, b) => b.pct - a.pct)[0];
  const row = mine || d.example;
  if (!row) return null;

  return (
    <section className="mt-4 border border-[var(--wl-line)] bg-[var(--wl-panel)] p-3.5 sm:p-4" data-testid="collection-strip">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <h2 className="font-sg text-lg font-bold uppercase tracking-[-0.035em] text-[var(--wl-text)]">{t("wl.coll_strip_title")}</h2>
        <Link to="/my-collection" className="wl-mono text-[9.5px] uppercase tracking-[.04em] text-[var(--wl-accent)] hover:underline" data-testid="collection-strip-link">
          {t("wl.coll_strip_link")}
        </Link>
      </div>
      <p className="mt-1 wl-mono text-[10px] leading-relaxed text-[var(--wl-muted)]">{t("wl.coll_strip_sub")}</p>
      <div className="mt-3 max-w-md">
        <div className="flex items-baseline justify-between gap-2">
          <span className="wl-mono text-[10.5px] uppercase tracking-[.04em] text-[var(--wl-text)]" data-testid="collection-strip-label">
            <CheckSquare className="mr-1 inline h-3 w-3 text-[var(--wl-accent)]" />
            {row.owned} / {row.total} · {row.set_name}
          </span>
          <span className="wl-mono text-[11px] font-bold tabular-nums text-[var(--wl-accent)]">{row.pct} %</span>
        </div>
        <div className="mt-1.5">
          <ProgressBar owned={row.owned} total={row.total} pct={row.pct} testid="collection-strip-bar" />
        </div>
        {!mine && (
          <span className="wl-mono mt-1.5 inline-block text-[9px] uppercase tracking-[.06em] text-[var(--wl-muted)]" data-testid="collection-strip-example-tag">
            {t("wl.coll_strip_example")}
          </span>
        )}
      </div>
    </section>
  );
}
